module.exports = __webpack_public_path__ + "img/sotc.c06823db.png";